// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setResponsibleList,
  setPatientGoalList,
  setPatientGoalValue,
  setGoalList,
  setGoalCategoryList,
  setExpandedPatientInterventionList,
  setPatientInterventionValue,
  setInterventionList,
  setAddActivityInterventionList,
  setInterventionTypeList,
  resetGoal,
  setPatientBillingCodes,
  setModalPatientGoalList,
  setPatientCarePlanReviews,
  setPatientCarePlanChangeLog,
  setPatientActiveCarePlanCount
} from 'src/store/modules/patient/carePlan'

const initialState = {
  responsibleList: [],
  goalList: [],
  goalCategoryList: [],
  patientGoalList: [],
  patientGoalValue: {},
  interventionList: [],
  interventionTypeList: [],
  expandedPatientInterventionList: {},
  patientInterventionValue: {},
  patientBillingCodes: {},
  patientModalGoalList: [],
  addActivityInterventionList: [],
  patientReviews: [],
  patientLogs: [],
  activeCarePlanCount: {}
}

export default handleActions(
  {
    [setResponsibleList](state, { payload: responsibleList }) {
      return {
        ...state,
        responsibleList
      }
    },

    [setGoalList](state, { payload: goalList }) {
      return {
        ...state,
        goalList
      }
    },

    [setGoalCategoryList](state, { payload: goalCategoryList }) {
      return {
        ...state,
        goalCategoryList
      }
    },

    [setPatientGoalList](state, { payload: patientGoalList }) {
      return {
        ...state,
        patientGoalList
      }
    },

    [setModalPatientGoalList](state, { payload: patientModalGoalList }) {
      return {
        ...state,
        patientModalGoalList
      }
    },

    [setPatientGoalValue](state, { payload: patientGoalValue }) {
      return {
        ...state,
        patientGoalValue
      }
    },

    [setInterventionList](state, { payload: interventionList }) {
      return {
        ...state,
        interventionList
      }
    },

    [setAddActivityInterventionList](
      state,
      { payload: addActivityInterventionList }
    ) {
      return {
        ...state,
        addActivityInterventionList
      }
    },

    [setExpandedPatientInterventionList](
      state,
      { payload: expandedPatientInterventionList }
    ) {
      return {
        ...state,
        expandedPatientInterventionList
      }
    },

    [setPatientInterventionValue](
      state,
      { payload: patientInterventionValue }
    ) {
      return {
        ...state,
        patientInterventionValue
      }
    },

    [setInterventionTypeList](state, { payload: interventionTypeList }) {
      return {
        ...state,
        interventionTypeList
      }
    },

    [setPatientBillingCodes](state, { payload: patientBillingCodes }) {
      return {
        ...state,
        patientBillingCodes
      }
    },

    [setPatientCarePlanReviews](state, { payload: patientReviews }) {
      return {
        ...state,
        patientReviews
      }
    },

    [setPatientCarePlanChangeLog](state, { payload: patientLogs }) {
      return {
        ...state,
        patientLogs
      }
    },

    [setPatientActiveCarePlanCount](state, { payload: activeCarePlanCount }) {
      return {
        ...state,
        activeCarePlanCount
      }
    },

    [resetGoal](state) {
      return {
        ...initialState,
        activeCarePlanCount: state?.activeCarePlanCount || {}
      }
    }
  },
  initialState
)
